<template>
    <div class="base-visitor" :class="{'visitor-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="header">
                <div class="back-img" @click="$router.back()">
                    <img class="back" src="~images/back.png" />
                </div>
                <div class="title">游客体验模式</div>
            </div>
            <div class="content-auto">
                <div class="tips">
                    <div>若暂不实名，为游客体验模式，您可以直接进入游戏进行体验，但也有一些限制：</div>
                    <div class="mar">▪不能进行充值和付费消费</div>
                    <div class="mar">▪每日游戏时长不能超过1小时</div>
                    <div class="mar">为提供更好的游戏体验，建议您进行实名认证。</div>
                </div>
            </div>
        </div>
        <div class="btn">
            <div class="item" @click="toGame">我知道了</div>
            <div class="item" @click="$router.back()">前往认证</div>
        </div>
    </div>
</template>

<script>
    import DeviceDetector from "device-detector-js";
    export default {
        name: 'BaseVisitor',
        data () {
            return {
                loginData: {},
                h5LoginData:{},
                userData: {}
            }
        },
        methods: {
            mobileInfoInit() {
                // 设备信息
                const deviceDetector = new DeviceDetector();
                const userAgent = window.navigator.userAgent;
                let device = deviceDetector.parse(userAgent);
                this.code = device.device.model
            },
            // 进入游戏
            toGame () {
                console.log('this.userData',this.userData)
                console.log('this.h5LoginData',this.h5LoginData)
                let options = {
                    uid:  this.userData?this.userData.data.uid:this.h5LoginData.uid,
                    app_uid: this.$route.query.id,
                    token: this.userData?this.userData.data.token:this.h5LoginData.token,
                    appid: this.h5LoginData ? this.h5LoginData.appid : this.loginData.appid, //渠道ID
                    system: this.config.system, //系统
                    machine_code: this.code ? this.code : this.h5LoginData ? this.h5LoginData.machine_code : 'XXXX', //设备号
                };
                options.sign = this.util.getSign(options, this.h5LoginData ? this.h5LoginData.appkey : this.loginData.appkey);
                options.real_name_verify = 0;   // 是否需要实名验证，1为需要，0为不需要
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=check_switch_user', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.onLoginSucceed(res.data.data.app_uid, res.data.data.token, res.data.data.uid, res.data)
                    } else {
                        this.msg = res.data.msg
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                        this.onLoginError(res.data.msg)
                    }
                }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
            },
            // 进入游戏成功回调
            onLoginSucceed (account, token, uid,data) {
                let that = this
                if(this.h5LoginData){
                    // 进入用户中心前将一些数据保存到accountData
                    sessionStorage.setItem('accountData', JSON.stringify(data.data))
                    this.$router.push('/user')
                    // 传给插件accountData
                    window.parent.postMessage({type:"accountData",info:JSON.stringify(data)}, '*')
                }
                // if (that.config.system == 2) {
                //     window.webkit.messageHandlers.wz_callOC.postMessage({
                //         method: 'onLoginSucceed',
                //         param: {
                //             account: account,
                //             token: token,
                //             uid: uid,
                //             status: that.userData.data.is_auth
                //         }
                //     })
                // } else {
                //     window.Android.onLoginSucceed(account, token, uid, that.userData.data.is_auth)
                // }
            },
            // 进入游戏失败回调
            onLoginError (error) {
                // if (this.config.system == 2) {
                //     window.webkit.messageHandlers.wz_callOC.postMessage({
                //         method: 'onLoginFailed'
                //     })
                // } else {
                //     window.Android.onLoginFailed(error)
                // }
            }
        },
        created () {
            this.loginData = JSON.parse(sessionStorage.getItem('loginData'))
            this.h5LoginData = JSON.parse(sessionStorage.getItem('h5LoginData'))
            this.userData =JSON.parse(sessionStorage.getItem('userData'))
            this.mobileInfoInit()
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22;
    // 横屏css
    .base-visitor {
        width: 864px;
        overflow: hidden;
        padding-bottom: 60px;
        border-radius: 18px;
        background: rgba(0, 0, 0, 0.8);
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.3s;
        .content {
            flex: 1;
            overflow-y: scroll;
            .header {
                height: 132px;
                background: rgba($color, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                .back-img {
                    width: 192px;
                    height: 132px;
                    position: absolute;
                    left: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .back {
                        width: 72px;
                        height: 72px;
                    }
                }
                .title {
                    font-size: 51px;
                    text-align: center;
                }
            }
            .content-auto {
                padding: 0 60px;
                overflow: hidden;
                .tips {
                    font-size: 39px;
                    margin: 60px 0 30px;
                }
                .tips .mar {
                    margin-top: 40px;
                }
            }
        }
        .btn {
            height: 120px;
            margin: 40px 60px 0 60px;
            display: flex;
            justify-content: space-between;
            .item {
                width: 345px;
                height: 120px;
                color: #fff;
                font-size: 39px;
                border-radius: 18px;
                background: $color;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .item:first-child {
                background: rgba($color, 0.5);
            }
        }
    }
    // 竖屏css
    .visitor-sp {
        width: 1570px;
        padding-bottom: 90px;
        border-radius: 32px;
        .content {
            .header {
                height: 240px;
                .back-img {
                    width: 290px;
                    height: 240px;
                    .back {
                        width: 130px;
                        height: 130px;
                    }
                }
                .title {
                    font-size: 92px;
                }
            }
            .content-auto {
                padding: 0 90px;
                .tips {
                    font-size: 70px;
                    margin: 90px 0 54px;
                }
                .tips .mar {
                    margin-top: 72px;
                }
            }
        }
        .btn {
            height: 200px;
            margin: 72px 90px 0 90px;
            .item {
                width: 627px;
                height: 200px;
                font-size: 70px;
                border-radius: 32px;
            }
        }
    }
</style>